<i18n>
{
	"en": {
		"cancelLabel": "Cancel",
		"title": "Search for Customer",
		"chooseCustomer": "Choose Customer",
		"searchPlaceholder": "Search text",
		"name": "Name",
		"street": "Street",
		"postalPlace": "City",
		"postalCode": "Postal Code",
		"countryCode": "Country Code",
		"phone": "Telephone",
		"email": "Mail",
		"customerNo": "Customer No.",
		"failedToFetch": "Failed to search for customers"
	},
	"no": {
		"cancelLabel": "Avbryt",
		"title": "Søk etter kunde",
		"chooseCustomer": "Velg kunde",
		"searchPlaceholder": "Søketekst",
		"name": "Navn",
		"street": "Gate",
		"postalPlace": "Poststed",
		"postalCode": "Postnummer",
		"countryCode": "Landkode",
		"phone": "Telefon",
		"email": "Mail",
		"customerNo": "Kundenr.",
		"failedToFetch": "Kunne ikke søke etter kunder"
	}
}
</i18n>

<template>
	<t-dialog
		:icon="icon"
		:isShown="isShown"
		:title="$t('title')"
		:confirmLabel="$t('chooseCustomer')"
		:cancelLabel="$t('cancelLabel')"
		:isConfirmDisabled="selectedCustomer === undefined"
		iconType="bp"
		@close="onClose"
		@ok="onOk"
		@shown="onShown"
	>
		<t-form-group>
			<t-search-input v-model="searchValue" :placeholder="$t('searchPlaceholder')"/>
			<t-grid
				v-if="showGrid"
				:items="customers"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="40"
				:showFilters="false"
				:singleSelect="true"
				:selectableMode="['row']"
				selectable
				style="height: 400px; width: 500px;"
				@selected="setSelectedCustomer"
				@enter="onEnter"
				@rowDoubleClick="selectAndClose"
			/>
		</t-form-group>
	</t-dialog>
</template>

<script>
import { mapState, mapActions } from '../store/customers.store';

export default {
	name: 'CustomersDialog',
	props: {
		icon: String,
		isShown: Boolean,
		initialSearchValue: String
	},
	data() {
		return {
			searchValue: '',
			showGrid: false,
			searchTimeout: undefined,
			selectedCustomer: undefined,
			defaultColumnDefinition: { resizable: false, },
		};
	},
	computed: {
		...mapState(['customers']),
		columnDefinitions() {
			return [
				{
					field: 'name',
					displayName: this.$t('name'),
					minWidth: 300,
					resizable: true,
				},
				{
					field: 'customerNo',
					displayName: this.$t('customerNo'),
					type: 'number',
					minWidth: 80,
					resizable: true,
				},
				{
					field: 'street',
					displayName: this.$t('street'),
					minWidth: 180,
					resizable: true,
				},
				{
					field: 'postalCode',
					displayName: this.$t('postalCode'),
					width: 60,
					resizable: true,
				},
				{
					field: 'postalPlace',
					displayName: this.$t('postalPlace'),
					width: 60,
					resizable: true,
				},
				{
					field: 'countryCode',
					displayName: this.$t('countryCode'),
					width: 70,
					resizable: true,
				},
				{
					field: 'contactPhone',
					displayName: this.$t('phone'),
					width: 80,
				},
				{
					field: 'contactEmail',
					displayName: this.$t('email'),
					width: 200,
				},
			];
		}
	},
	watch: {
		searchValue(newVal) {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				this.updateFilteredItems(newVal);
			},200);
		}
	},
	methods: {
		...mapActions(['getCustomers']),
		async onShown() {
			if (this.initialSearchValue) {
				this.searchValue = this.initialSearchValue;
			}
			if (!this.customers.length) {
				this.updateFilteredItems(this.searchValue);
			}
			this.showGrid = true;
		},
		async updateFilteredItems(searchValue) {
			try {
				// getting all cusomers takes almost a minute on veøy møre
				// await this.getAllCustomers();
				await this.getCustomers(searchValue);
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToFetch')
				});
			}
		},
		selectAndClose(customerId) {
			if (!customerId) return;
			this.selectedCustomer = this.customers.find( x => x.id === customerId);
			this.onOk();
			this.onClose();
		},
		onEnter() {
			if (!this.selectedCustomer) return;
			this.onOk();
			this.onClose();
		},
		setSelectedCustomer(customerIds) {
			if (!customerIds) return;
			let customer = this.customers.find(x => x.id === customerIds[0]);
			this.selectedCustomer = customer;
		},
		onClose() {
			this.$emit('close');
			this.selectedCustomer = undefined;
			this.searchValue = '';
			this.showGrid = false;
		},
		onOk() {
			this.$emit('ok', this.selectedCustomer);
			this.selectedCustomer = undefined;
			this.searchValue = '';
			this.showGrid = false;
		}
	}
};
</script>

